import React from 'react';
import '../../../../css/CustomComponents/CustomSelect.css';
import { ArrowDown2 } from '../../../CustomComponents/SwiftIcon/Icons';
import { COLOR_VARS } from '../../../../exports/ColorVars';

class CustomSelectError extends React.PureComponent {


    constructor(props) {
        super(props);
        this.state = {
            heading: this.props.heading || 'Select',
            isListOpen: false,
            title: this.props.options[this.props.defaultIndex] || this.props.title,
            selectedIndex: this.props.defaultIndex
        }
        this.toggleSelect = this.toggleSelect.bind(this);
        this.closeSelect = this.closeSelect.bind(this);
        this.selectOption = this.selectOption.bind(this);
    }

    componentDidUpdate(prevProps) {

        if (this.props.defaultIndex !== prevProps.defaultIndex) {
            this.setState({
                title: this.props.options[this.props.defaultIndex] || this.props.title
            });
        }

        if (this.props.options !== prevProps.options) {
            this.setState({
                title: this.props.options[this.props.defaultIndex] || this.props.title
            });
        }

        const { isListOpen } = this.state;

        setTimeout(() => {
            if (isListOpen) {
                window.addEventListener('click', this.closeSelect)
            }
            else {
                window.removeEventListener('click', this.closeSelect)
            }
        }, 0)
    }

    toggleSelect() {
        this.setState((prevState) => ({
            isListOpen: !prevState.isListOpen
        }))
    }

    selectOption(indx, value) {
        this.setState({
            title: value,
            selectedIndex: indx,
            isListOpen: false
        }, () => {
            this.props.onTypeChange(value)
        });
    }

    closeSelect() {
        this.setState({
            isListOpen: false
        })
    }

    render() {

        const { width, height, options, error } = this.props;
        const { title, heading, isListOpen, selectedIndex } = this.state;

        return (
            <div className="custom-select" >

                <p className='select-title'>{heading}</p>
                <div className={`custom-select-header ${isListOpen ? 'open' : ''}`} onClick={() => { this.toggleSelect() }}>
                    <span className="custom-select-title">{title ? title : this.props.placeholder}</span>
                    <span>
                        <div style={{ transform: isListOpen ? 'rotate(180deg)' : 'rotate(0deg)', transition: 'transform 0.3s', display: 'flex' }}>
                            <ArrowDown2 size={16} color={COLOR_VARS["SWIFT_COLOR4"]} />
                        </div>
                    </span>
                    <div className={`custom-select-container overflow ${isListOpen ? 'open' : ''}`}>
                        {options.map((option, indx) => {
                            return <span key={indx}
                                className={selectedIndex === indx ? "custom-select-option option-selected" : "custom-select-option"}
                                onClick={(e) => {
                                    e.stopPropagation();
                                    this.selectOption(indx, option)
                                }}>
                                {option}
                            </span>
                        })}
                    </div>
                </div>
                <p
                    className={
                        error === ""
                            ? "error-text hide swift-error"
                            : "error-text swift-error"
                    }
                >
                    {error}
                </p>

            </div>
        )
    }
}

export default CustomSelectError;
